import {
  BackgroundImage,
  Box,
  Button,
  Card,
  Center,
  Flex,
  Image,
  Space,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import background from "assets/images/pngs/background.png";
import image11 from "@/assets/images/pngs/image11.png";
import { useLocation, useNavigate } from "react-router-dom";
import RoutesString from "@/pages/routesString";
import { useTranslation } from "react-i18next";

const LockDetailWrapper = () => {
  const { t } = useTranslation();

  const { state } = useLocation();
  const navigate = useNavigate();
  if (!state) return null;
  return (
    <>
      <Title fz={24} weight={900}>
        {t("ACCOUNTS_DETAIL")}
      </Title>
      <Space h={24} />
      <Center>
        <Card w={650} p={20} radius="md">
          <BackgroundImage src={background} radius="md" p={20}>
            <Stack align="center" spacing={10}>
              <Box w={140} h={88}>
                <Image src={image11} w={140} />
              </Box>
              <Text c="#fff">{t("REQUEST_SENT_AWAITING_APPROVAL")}</Text>
            </Stack>
          </BackgroundImage>
          <Stack spacing={12} mt={12}>
            <Flex justify="space-between">
              <Text c="dimmed" fz={14}>
                {t("REFERENCE_ID")}
              </Text>
              <Text fw={500} c="#121826" fz={14}>
                {state?.dataConfirm?.approvalProcessInfo?.approvalProcessId}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text c="dimmed" fz={14}>
                {t("TRANSFER_TYPE")}
              </Text>
              <Text fw={500} c="#121826" fz={14}>
                {t("LOCK_ACCOUNT")}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text c="dimmed" fz={14}>
                {t("ACCOUNT_NICKNAME")}
              </Text>
              <Text fw={500} c="#121826" fz={14}>
                {state?.dataConfirm?.customerName}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text c="dimmed" fz={14}>
                {t("ACCOUNT_NUMBER")}
              </Text>
              <Text fw={500} c="#121826" fz={14}>
                {state?.dataConfirm?.accountNumber}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text c="dimmed" fz={14}>
                {t("AUTHORITY")}
              </Text>
              <Text fw={500} c="#121826" fz={14}>
                {state?.dataConfirm?.approvalProcessInfo?.numberOfApprovals}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text c="dimmed" fz={14}>
                {t("REVIEWER")}
              </Text>
              <Text fw={500} c="#121826" fz={14}>
                {state?.dataConfirm?.approvalProcessInfo?.approvalUserNames[0]}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text c="dimmed" fz={14}>
                {t("DATE_CREATED")}
              </Text>
              <Text fw={500} c="#121826" fz={14}>
                {state?.dataConfirm?.createdAt}
              </Text>
            </Flex>
            <Flex gap={10}>
              <Button
                sx={() => ({
                  width: "50%",
                  backgroundColor: "#F4F4F6",
                  color: "#525866",
                  borderRadius: "8px",
                  padding: "8px 10px",
                  cursor: "pointer",
                  fontWeight: 400,
                  "&:hover": {
                    backgroundColor: "#F4F4F6",
                  },
                })}
              >
                {t("CLOSE")}
              </Button>
              <Button
                type="submit"
                sx={() => ({
                  width: "50%",
                  backgroundColor: "#2A81D0",
                  color: "white",
                  borderRadius: "8px",
                  padding: "8px 10px",
                  cursor: "pointer",
                  fontWeight: 400,
                })}
                onClick={() => navigate(RoutesString.TransactionList)}
              >
                {t("LIST_TRACSACTIONS")}
              </Button>
            </Flex>
          </Stack>
        </Card>
      </Center>
    </>
  );
};
export default LockDetailWrapper;
